import { floatingColBody } from '@components/favorite/templates/floatingColBody';
import { l } from '@utils/toolbox';

/**
 * Favorite floating columnt
 * @param flight Object
 * @returns html String
 */
export const floatingCol = (flight, index, isPinned, favouriteSettings) => {
	if (!flight) {
		return '';
	}

	let flightStatus = 'good';

	if (flight.isPast) {
		flightStatus = 'past';
	} else if (flight.isOld) {
		flightStatus = 'old';
	} else if (isPinned) {
		flightStatus = 'pinned';
	} else if (flight.isAncient) {
		flightStatus = 'ancient';
	}

	return `<div class="floating-col" data-status="${flightStatus}" data-index="${index}">
		<div class="colTools">
			<span class="icon-filter-trans" data-action="pin"></span>
			<span class="icon-filter" data-action="unpin"></span>
			<span class="icon-loading" data-action="refresh"></span>
			<span class="icon-delete" data-action="delete"></span>
		</div>
		<div class="colHeader">
			<div class="colHeader--destination ${flight.tripType}">
				<div class="colHeader--from">${flight.from}</div>
				<div class="colHeader--to">${flight.to}</div>
			</div>
		</div>
		<div class="colBody">
			${floatingColBody(flight, favouriteSettings)}
			<div class="floating-colRow colRow-cta"><a class="goToFlight" target="_blank" href="${flight.url}">${l('favorite.tableMode.buyButton')}</a></div>
		</div>
		<div class="colInfo">
			${flightStatus === 'old' ? `<span class="colInfo--text">${l('fav.ui.needsRefresh')}</span>` : ''}
			${flightStatus === 'past' ? `<span class="colInfo--text" data-action="dismiss">${l('fav.ui.isOldRecord')}</span>` : ''}
			${flightStatus === 'ancient' ? `
				<span class="colInfo--text">${l('error.searchTooOld')}
					<a href="/redo/${flight.url}" class="otaLink trck_otaPrimary" rel="nofollow noopener noreferrer">
						<div class="abBuyBtn abBuyBtn--main">
							<div class="abBuyBtn__previewPrice">
								<span class="abBuyBtn__previewPrice--text">${l('showresult.message.oldDate.searchAgain')}</span>
							</div>
						</div>
					</a>
				</span>
			` : ''}
		</div>
    </div>`;
};
